export default "__VITE_ASSET__BY9au8f4__"